document.addEventListener('DOMContentLoaded', function () {
  var MOBILE_SHEET_MQ = '(max-width: 750px)';

  function isMobileBottomSheet() {
    return window.matchMedia(MOBILE_SHEET_MQ).matches;
  }

  function portalOptionsIfNeeded(options, dropdown) {
    if (!isMobileBottomSheet() || options.dataset.bagPortaled === 'true') return;
    options._bagPortalDropdown = dropdown;
    options._bagRestore = { parent: options.parentNode, nextSibling: options.nextSibling };
    document.body.appendChild(options);
    options.dataset.bagPortaled = 'true';
  }

  function restoreIfPortaled(options) {
    if (!options || options.dataset.bagPortaled !== 'true') return;
    var r = options._bagRestore;
    if (r && r.parent) {
      r.parent.insertBefore(options, r.nextSibling);
    }
    delete options._bagRestore;
    delete options._bagPortalDropdown;
    options.dataset.bagPortaled = 'false';
  }

  function getOptionsForDropdown(dropdown) {
    var local = dropdown.querySelector('[data-bag-options]');
    if (local) return local;
    var all = document.querySelectorAll('[data-bag-options]');
    for (var i = 0; i < all.length; i++) {
      if (all[i]._bagPortalDropdown === dropdown) return all[i];
    }
    return null;
  }

  function openSelector(dropdown) {
    var options = getOptionsForDropdown(dropdown);
    var trigger = dropdown.querySelector('[data-bag-trigger]');
    if (!options) return;

    if (isMobileBottomSheet()) {
      portalOptionsIfNeeded(options, dropdown);
      // Force browser to paint the off-screen state first, then animate in
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          options.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          document.body.classList.add('bag-selector-open');
        });
      });
    } else {
      options.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeSelector(dropdown) {
    var options = getOptionsForDropdown(dropdown);
    if (!options) return;
    var trigger = dropdown.querySelector('[data-bag-trigger]');

    options.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bag-selector-open');

    if (options.dataset.bagPortaled === 'true') {
      // Wait for slide-down transition to finish, then restore to DOM
      var handler = function () {
        options.removeEventListener('transitionend', handler);
        restoreIfPortaled(options);
      };
      options.addEventListener('transitionend', handler);
      // Fallback if transitionend doesn't fire
      setTimeout(function () {
        restoreIfPortaled(options);
      }, 400);
    }
  }

  function closeAllSelectors() {
    document.querySelectorAll('[data-bag-options].is-open').forEach(function (options) {
      var dropdown = options.closest('[data-bag-selector]') || options._bagPortalDropdown;
      if (dropdown) closeSelector(dropdown);
    });
  }

  document.querySelectorAll('[data-bag-selector]').forEach(function (selector) {
    var trigger = selector.querySelector('[data-bag-trigger]');
    var options = selector.querySelector('[data-bag-options]');
    var hiddenInput = selector.querySelector('[data-bag-input]');
    var errorMsg = selector.querySelector('[data-bag-error]');

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = options.classList.contains('is-open');

      closeAllSelectors();

      if (!isOpen) {
        openSelector(selector);
      }
    });

    selector.querySelectorAll('[data-bag-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var name = option.getAttribute('data-bag-name');
        var image = option.getAttribute('data-bag-image');

        hiddenInput.value = name;

        trigger.classList.remove('bag-color-selector__trigger--error');
        if (errorMsg) errorMsg.classList.remove('is-visible');

        var html = '';
        if (image) {
          html += '<span class="bag-color-selector__selected">';
          html += '<img src="' + image + '" alt="' + name + '" width="36" height="36" class="bag-color-selector__selected-image">';
          html += '<span class="bag-color-selector__selected-name">' + name + '</span>';
          html += '</span>';
        } else {
          html += '<span class="bag-color-selector__selected">';
          html += '<span class="bag-color-selector__selected-name">' + name + '</span>';
          html += '</span>';
        }

        var placeholder = trigger.querySelector('.bag-color-selector__placeholder');
        var selected = trigger.querySelector('.bag-color-selector__selected');
        if (placeholder) placeholder.remove();
        if (selected) selected.remove();
        trigger.insertAdjacentHTML('afterbegin', html);

        selector.querySelectorAll('[data-bag-option]').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        option.classList.add('is-selected');

        closeSelector(selector);
      });
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bag-selector]') && !e.target.closest('[data-bag-options]')) {
      closeAllSelectors();
    }
  });

  var mq = window.matchMedia(MOBILE_SHEET_MQ);
  function onViewportSheetModeChange() {
    if (!isMobileBottomSheet()) {
      document.querySelectorAll('[data-bag-options][data-bag-portaled="true"]').forEach(function (options) {
        restoreIfPortaled(options);
      });
    }
  }
  if (mq.addEventListener) {
    mq.addEventListener('change', onViewportSheetModeChange);
  } else if (mq.addListener) {
    mq.addListener(onViewportSheetModeChange);
  }

  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
    form.addEventListener(
      'submit',
      function (e) {
        var allValid = true;

        document.querySelectorAll('[data-bag-required] [data-bag-input]').forEach(function (input) {
          if (input.form !== form) return;

          if (!input.value) {
            allValid = false;
            var selector = input.closest('[data-bag-selector]');
            var trigger = selector.querySelector('[data-bag-trigger]');
            var errorMsg = selector.querySelector('[data-bag-error]');

            trigger.classList.add('bag-color-selector__trigger--error');
            if (errorMsg) errorMsg.classList.add('is-visible');
          }
        });

        if (!allValid) {
          e.preventDefault();
          e.stopImmediatePropagation();

          var firstError = document.querySelector('.bag-color-selector__trigger--error');
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      },
      true
    );
  });
});
